import React from 'react';
import Modal from 'chameleon/packages/blue-book-player/library/modal';
import MoreMenuContent from './MoreMenuContent';

const MobileMoreMenuModal = ({
  onClose,
  subjectId,
  onReferenceSheetClick,
  onCalculatorClick,
  onAnnotationClick,
  toggleExitAssignmentModal,
  toggleSubmitConfirmDialog,
  onLineReaderClick,
  isPreviewPlayer,
  toggleHelpModal,
}) => {
  const wrapActionWithClose = (action) => (actionProp) => {
    action(actionProp);
    onClose();
  };

  return (
    <Modal
      closeButtonClassName="absolute top-[16px] right-[16px]"
      onClose={onClose}
      size="full"
      dialogClassName="z-blueBook_pauseScreen"
      showCloseButton
      contentWithSpacing
      headerWithBorder={false}
    >
      <div className="text-left">
        <h1 className="font-normal pl-[16px] text-5xl">Menu</h1>
        <MoreMenuContent
          isPreviewPlayer={isPreviewPlayer}
          openExitAssignmentModal={wrapActionWithClose(
            toggleExitAssignmentModal,
          )}
          openSubmitConfirmDialog={wrapActionWithClose(
            toggleSubmitConfirmDialog,
          )}
          openSub
          openHelpModal={wrapActionWithClose(toggleHelpModal)}
          onLineReaderClick={wrapActionWithClose(onLineReaderClick)}
          subjectId={subjectId}
          onReferenceSheetClick={wrapActionWithClose(onReferenceSheetClick)}
          onCalculatorClick={wrapActionWithClose(onCalculatorClick)}
          onAnnotationClick={wrapActionWithClose(onAnnotationClick)}
        />
      </div>
    </Modal>
  );
};

export default MobileMoreMenuModal;
